import type { DefaultTheme } from 'styled-components';
import styled from 'styled-components';

export type IconNames =
  | 'icon-address'
  | 'icon-chat'
  | 'icon-coin'
  | 'icon-crease'
  | 'icon-dropoff'
  | 'icon-folding'
  | 'icon-hanger'
  | 'icon-items-at-facility'
  | 'icon-order-type'
  | 'icon-orders'
  | 'icon-payment'
  | 'icon-pickup'
  | 'icon-pricing'
  | 'icon-stain-and-damage'
  | 'icon-starch'
  | 'icon-stepper-1'
  | 'icon-stepper-2'
  | 'icon-stepper-3'
  | 'icon-support'
  | 'icon-question';

export interface IconProps {
  size?: number;
  className?: IconNames;
  isDisabled?: boolean;
  isActive?: boolean;
  numPaths?: number;
  hasFixedStyle?: boolean;
}

const createStyles = (numPaths: number, theme: DefaultTheme) => {
  let styles = '';

  if (numPaths === 0) {
    styles += `
      ::before {
        color: ${theme.colors?.success};
      }

      &.filled {
        ::before {
          color: ${theme.icon?.color};
        }
      }

      &.disabled {
        ::before {
          color: ${theme.icon?.disabledColor};
        }
      }
    `;
  }

  for (let i = 0; i < numPaths; i += 1) {
    styles += `
      .path${i + 1}::before {
        color: ${theme.text?.success};
        opacity: ${i === 0 ? 0.1 : 1};
      }

      &.filled {
        .path${i + 1}::before {
          color: ${theme.icon?.color};
        }
      }

      &.disabled {
        .path${i + 1}::before {
          color: ${theme.icon?.disabledColor};
        }
      }
    `;
  }

  return styles;
};

export const StyledIcon = styled.span<{ size?: number; $numpaths?: number; $hasfixedstyle?: 'true' | 'false' }>`
  ${({ $numpaths = 2, theme, $hasfixedstyle }) => ($hasfixedstyle === 'true' ? '' : createStyles($numpaths, theme))}
  font-size: ${({ size = 38 }) => size}px;
`;
